import { createBrowserRouter, Outlet } from 'react-router-dom'

import { AppProviders } from '@/app/providers'
import { ScrollToTop } from '@/app/scroll-to-top'
import { appRoutes } from '@/app/routes'

function AppLayout() {
  return (
    <AppProviders>
      <ScrollToTop />
      <Outlet />
    </AppProviders>
  )
}

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: appRoutes,
  },
])
